// Polling helpers for async-generated report/summary entities that move through
// a pending → processing → completed | failed lifecycle.

/** How often (ms) to re-poll a report's detail view while it is still generating. */
export const REPORT_POLL_INTERVAL_MS = 5000;

// Poll a report's detail view only while it is still generating. Returning a
// number keeps React Query refetching a report opened in the pending/processing
// state so it auto-advances to its completed (or failed) layout without a manual
// refresh; returning false stops polling once the report settles.
export function reportPollInterval(report?: { status?: string }): number | false {
  const status = report?.status;
  return status === 'processing' || status === 'pending' ? REPORT_POLL_INTERVAL_MS : false;
}
